import {useMutation} from 'react-query';
import {apiService} from '~services/ApiService';
import {useUserStore} from '~providers/userStore/zustand';

interface BlockUnblockUserRequest {
  blocker_id: string;
  blocked_id: string;
  reason?: string;
}

interface BlockUnblockUserResponse {
  success: boolean;
  message?: string;
}

export function useBlockUser() {
  const mutation = useMutation(
    async ({blocked_id, reason = 'Blocked from event'}: {blocked_id: string; reason?: string}) => {
      const currentUserId = useUserStore.getState().user?.uid;
      const token = useUserStore.getState().token;

      if (!currentUserId) {
        throw new Error('User not authenticated');
      }

      const blockData: BlockUnblockUserRequest = {
        blocker_id: currentUserId,
        blocked_id,
        reason,
      };
      
      return await apiService.post<BlockUnblockUserResponse>('users/block', blockData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
    },
  );

  return mutation;
}

export function useUnblockUser() {
  const mutation = useMutation(
    async ({blocked_id, reason = 'Unblocked from event'}: {blocked_id: string; reason?: string}) => {
      const currentUserId = useUserStore.getState().user?.uid;
      const token = useUserStore.getState().token;

      if (!currentUserId) {
        throw new Error('User not authenticated');
      }

      const unblockData: BlockUnblockUserRequest = {
        blocker_id: currentUserId,
        blocked_id,
        reason,
      };

      return await apiService.post<BlockUnblockUserResponse>('users/unblock', unblockData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
    },
  );

  return mutation;
}
